'use client';

import React, { useState } from 'react';
import Cookies from 'js-cookie';
import { Button } from '@/shared/ui/form/button/button';
import { Wrapper, Dot, Header, Label, ToggleButton, ButtonRow, StatusText } from './styles';
import type { ButtonProps } from '@/shared/ui/form/button/button';
import { fetcherWithToken } from '@/shared/api/fetcher';
import {
  getCurrentBrand,
  type Brand,
} from '@/shared/config/brand-by-target.mjs';

const BRANDS: { key: Brand; label: string; activeVariant: ButtonProps['variant'] }[] = [
  { key: 'pw', label: 'PW', activeVariant: 'blue' },
  { key: 'lm', label: 'LM', activeVariant: 'danger' },
  { key: 'ph', label: 'PH', activeVariant: 'orange' },
  { key: 'ph2', label: 'PH2', activeVariant: 'yellow' },
];

const HOSTNAMES: Record<Brand, string> = {
  pw: process.env.NEXT_PUBLIC_HOSTNAME_DEV_PW ?? '',
  lm: process.env.NEXT_PUBLIC_HOSTNAME_DEV_LM ?? '',
  ph: process.env.NEXT_PUBLIC_HOSTNAME_DEV_PH ?? '',
  ph2: process.env.NEXT_PUBLIC_HOSTNAME_DEV_PH2 ?? '',
};

export function DevBrandSwitcher() {
  const [status, setStatus] = useState<'idle' | 'loading' | 'restarting'>('idle');
  const [collapsed, setCollapsed] = useState(true);

  const current = getCurrentBrand();

  if (collapsed) {
    return <Dot onClick={() => setCollapsed(false)} title="BRAND" />;
  }

  const switchBrand = async (brand: Brand) => {
    if (brand === current || status !== 'idle') return;
    setStatus('loading');

    await fetcherWithToken('/logout').catch(() => {});
    Cookies.remove('sessionId');

    await fetch('/api/dev/switch-brand', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ brand }),
    });

    setStatus('restarting');

    const tryReload = () => {
      fetch('/')
        .then(() => window.location.reload())
        .catch(() => setTimeout(tryReload, 800));
    };
    setTimeout(tryReload, 1500);
  };

  return (
    <Wrapper>
      <Header>
        <Label>BRAND [{current.toUpperCase()}]</Label>
        <ToggleButton onClick={() => setCollapsed(true)}>✕</ToggleButton>
      </Header>
      <ButtonRow>
        {BRANDS.map(({ key, label, activeVariant }) => (
          <Button
            key={key}
            variant={current === key ? activeVariant : 'secondary'}
            disabled={status !== 'idle'}
            onClick={() => switchBrand(key)}
          >
            {label}
          </Button>
        ))}
      </ButtonRow>
      <StatusText>
        {status === 'loading' && '⏳ Обновляем .env...'}
        {status === 'restarting' && '🔄 Сервер перезапускается...'}
        {status === 'idle' && `↳ ${HOSTNAMES[current]}`}
      </StatusText>
    </Wrapper>
  );
}
